module.exports = __webpack_public_path__ + "img/Jonathan-Saporta.fd160694.png";